import { render, staticRenderFns } from "./AlternativeProductsDialog.vue?vue&type=template&id=468f8828"
import script from "./AlternativeProductsDialog.vue?vue&type=script&lang=js"
export * from "./AlternativeProductsDialog.vue?vue&type=script&lang=js"
import style0 from "./AlternativeProductsDialog.vue?vue&type=style&index=0&id=468f8828&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F03-organisms%2Falternative-products-dialog%2FAlternativeProductsDialog.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports